import { MessageCircle, Headphones } from "lucide-react";
import { SupportVisual } from "@/components/sections/ContactVisuals";

const numbers = ["1169268010", "7858007399", "8076463499", "9117723765"];

const formatNumber = (n) => n.replace(/(\d{4})(\d{3})(\d{3,4})/, "$1 $2 $3");

export default function SupportTeam() {
  return (
    <section data-testid="support-team-section" className="relative py-16 sm:py-20 bg-paper-soft">
      <div className="absolute inset-0 bg-dots opacity-50 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <div className="surface-strong rounded-2xl overflow-hidden reveal">
          <div className="grid md:grid-cols-12 gap-0">
            <div className="md:col-span-5 p-6 sm:p-7">
              <SupportVisual />
            </div>

            <div className="md:col-span-7 p-6 sm:p-8 flex flex-col justify-center">
              <div className="flex items-start gap-4">
                <div className="grid place-items-center w-11 h-11 rounded-xl bg-gradient-to-br from-[#0066ff] to-[#10b981] text-white">
                  <Headphones className="w-5 h-5" strokeWidth={2.4} />
                </div>
                <div>
                  <div className="text-xs font-mono-d uppercase tracking-[0.28em] text-[#10b981]">
                    Support Team
                  </div>
                  <h3 className="font-display text-xl sm:text-2xl font-bold text-[#0a0e1a] mt-1">
                    Reach our specialists on WhatsApp
                  </h3>
                  <p className="text-sm text-[#475569] mt-1">
                    Tap any number below to start a chat — round-the-clock availability.
                  </p>
                </div>
              </div>

              <div className="mt-6 flex flex-wrap gap-3">
                {numbers.map((n) => (
                  <a
                    key={n}
                    data-testid={`support-number-${n}`}
                    href={`https://wa.me/91${n}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white border border-[#e6ecff] hover:border-[#10b981]/50 transition-all hover:-translate-y-0.5 ring-soft"
                  >
                    <span className="grid place-items-center w-7 h-7 rounded-full bg-[#10b981]/12 group-hover:bg-[#10b981]/22 transition-colors">
                      <MessageCircle className="w-3.5 h-3.5 text-[#10b981]" />
                    </span>
                    <span className="font-mono-d text-sm text-[#0a0e1a] font-bold">+91 {formatNumber(n)}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
